import { LoginDialogComponent } from './../../../dialogs/auth-login/auth-login-dialog.component';
import { CheckForExistingMemberRequest } from './../../../models/ss-api/requests/check.for.existing.member.request';
import { BillingRecurringTypes } from '../../../models/ss-api/price.billing.cycle';
import { HttpError } from '../../../models/errors/HttpError';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import * as moment from 'moment';
import Swal from 'sweetalert2';
import { xToastr, ToastrTypes } from 'app/shared/Toastr';

import { ssApiService } from 'app/services/ss-api.service';
import { NewMemberRequest } from 'app/models/ss-api/requests/new.member.request';
import { PublicOrderProductsResponseArray, PublicOrderProductsResponse } from 'app/models/ss-api/responses/public.order.products.response';
import { UpdateCartRequest } from 'app/models/ss-api/requests/update.cart.request';

import { DialogService } from 'primeng/dynamicdialog';
import { CompleteOrderDialogComponent } from 'app/dialogs/complete-order/complete-order-dialog.component';
import { GlobalServices } from 'app/services/global.service';
import { NewMemberResponse } from '../../../models/ss-api/responses/new.member.response';
import { Title } from '@angular/platform-browser';
import { CreditCardValidators } from 'angular-cc-library';
import { CheckForExistingMemberResponse } from 'app/models/ss-api/responses/check.for.existing.member.response';

import { CountryList, CountryListItem } from '../../../helpers/country.list';
import { StateList, StateListItem, DualStateZipcodeList } from '../../../helpers/state.list';

import { CreditCardHelper } from '../../../helpers/creditcard';
import { CreditCardTypes } from 'app/models/ss-api/responses/credit.card.response';


function CustomCreditCardValidator(c: UntypedFormControl) {
    
    let cardType = CreditCardHelper.GetCardTypes( c.value );

    if( cardType == CreditCardTypes.Unknown || cardType == null ) {
        return {
            CustomCreditCardValidator: {
                valid: false
            }
        }
    } else {
        return null;
    }

}

@Component({
    selector: 'app-order-form',
    templateUrl: './order-form-v2.component.html',
    styleUrls: ['./order-form-v2.component.scss'],
    providers: [DialogService]
})
export class OrderFormComponentV2 implements OnInit, OnDestroy {

    // *********************************************************************************************************** //
    // orderFormVersion - Update this whenever a major change is made to form
    //
    // if updated, a corresponding order form component needs to be created and routed on the reports panel
    //
    //orderFormVersion ------- WE GET THIS FROM THE GLOBALS, IT IS IMPERATIVE THAT IT BE UPDATED!!! YOOOOUUUU HAAAAAVE BEEEEEN WAARRRRNEEDD!!!!
    // *********************************************************************************************************** //


    /* *******************************************
        order form link URLs:
        Vip3D Monthly -- https://members.structurestudios.com/order-form/product/0/1/1
        Vip3D Special -- https://members.structurestudios.com/order-form/product/VIP3D_-_Special1/1/1

    ******************************************** */
    IsBusy: boolean = true;

    isSpecial: boolean = false;
    isPromo: boolean = false;

    isCheckingMember : boolean = false;

    // products
    Products: PublicOrderProductsResponseArray;
    SelectedProduct: PublicOrderProductsResponse = new PublicOrderProductsResponse();
    SelectedBillingCycle: BillingRecurringTypes = BillingRecurringTypes.Monthly;
    SelectedPrice: number = 0;
    SelectedSetupFee: number = 0;
    ReferallInfo: any;

    yardAddOnOption: boolean = false;
    yardAddOn: boolean = false;
    yardPrice: number = 0;
    yardSetup: number = 0;
    // ID's FROM ROUTE PARAMTERS
    routeParams: object;
    marketTag: string;


	trainingValue : string = "2,375";

    // Cart ID
    CartID: string;
    SkipUpdteCart: boolean = true; // for initial change detects like dropdowns
    LastUpdateCartRequest: UpdateCartRequest;

    // form
    OrderForm: UntypedFormGroup;

    orderFormSubmited: boolean = false;

    selectedCycle: number = 1;
    formProductClass: string;

    //Tax - Hard Code to TX
    /*
    TaxEnabled: boolean = true;
    TaxCalculated: boolean = true;
    State: string = "TX";
    TaxRateDisplay: string = "8.25%";
    TaxAmount: number = 14.25;
    TaxRate: number = 8.25;
    YardTax: number = 0;
    */
    
    //Tax - Emulate First Load
    /*
    TaxEnabled: boolean = true;
    TaxCalculated: boolean = false;
    State: string = "";
    TaxRateDisplay: string = "";
    TaxAmount: number = 0;
    YardTax: number = 0;
    */

    //Tax - Live
    TaxEnabled: boolean = false;
    TaxCalculated: boolean = false;
    State: string = "";
    TaxRateDisplay: string = "";
    TaxAmount: number = 0;
    YardTax: number = 0;
    TaxRate: number = 0;

    @ViewChild('orderForm') form;

    @ViewChild('billingCycleSelect') billingCycleSelect;
    @ViewChild('EmailField') EmailField;
    @ViewChild('ccNumber') ccNumber;

    @ViewChild('phoneNumber') phoneNumber;

    Year: number = new Date().getFullYear();
    YearRange: any[] = [];
    
    // CC Name Variables
    ccFirstName = '';
    ccLastName = '';
    ccardType: number;
    
    cardType : CreditCardTypes = CreditCardTypes.Unknown;

    ccardTypeClass : string;

    ExpirationChanged: boolean = false;

    // DATA SUBSCRIPTION VARIABLES
    paramsSubscribe: any;

    EdgeInterval;

    thisIsDev: boolean = false;


    countryList : CountryListItem[] = CountryList.Countries();
    stateList : StateListItem[] = StateList.States();


    constructor(public api: ssApiService,
        private route: ActivatedRoute,
        private router: Router,
        // private sweetAlertService: SweetAlertService,
        private dialogService: DialogService,
        private gb: GlobalServices,
        private titleService: Title) {

        this.paramsSubscribe = this.route.params.subscribe(params => this.routeParams = params);

    }

    ngOnDestroy() {
        this.paramsSubscribe.unsubscribe();
    }

    ngOnInit() {


        if (window.navigator.platform.includes('Mac')) {
            Swal.fire({
                // type: 'warning',
                // title: 'Mac Not Supported',
                text: 'Please note the software is not compatible with Mac',
                confirmButtonText: 'I understand',
                allowOutsideClick: false
            }).then( (confirm) => {

            }, (dismiss) => {
                window.history.back();
            });
        }

        // Set page title
        this.titleService.setTitle('Order Form');

        const usZipValidators = [
            Validators.required,
            Validators.minLength(5),
        ];

        // this.showCompleteOrderDialog();
        // initialize order form
        this.OrderForm = new UntypedFormGroup({
            firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(2), Validators.pattern('[a-zA-Z ]*')] ),
            lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(2), Validators.pattern('[a-zA-Z ]*')]),
            company: new UntypedFormControl('', [Validators.required, Validators.minLength(2), Validators.pattern('.*[a-zA-Z].*') ] ),
			//'phone': new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern('^[0-9 \+\-\]+$')]),
			phone: new UntypedFormControl('', [Validators.required, Validators.minLength(14) ]),
            email: new UntypedFormControl('', [Validators.required, Validators.email]),
            // 'email1': new FormControl("", [Validators.required, Validators.email]),
            password: new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),
            password1: new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),

            address1: new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),
            city: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
            state: new UntypedFormControl('NA', [Validators.required, Validators.minLength(2)]),
            statepicker: new UntypedFormControl('', [Validators.required]),
			zipCode: new UntypedFormControl('', usZipValidators),
			country: new UntypedFormControl('US', [Validators.required]),
            ccNameOnCard: new UntypedFormControl('', [Validators.required]),
            
            //ccNr: new FormControl('', [<any>CreditCardValidator.validateCCNumber]), //creditCard: new FormControl('', [<any>CreditCardValidator.validateCCNumber]),
            ccNr: new UntypedFormControl('', [<any>CreditCardValidators.validateCCNumber, Validators.required, CustomCreditCardValidator]),

            ccExpMonth: new UntypedFormControl(this.ThisMonth(), [Validators.required]),
            ccExpYear: new UntypedFormControl(this.Year, [Validators.required]),
            ccCVC: new UntypedFormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(4), Validators.pattern('^[0-9]+$')]),
            yardAddOn: new UntypedFormControl(''),
            confirmInitials: new UntypedFormControl('', [Validators.required]),
        });

		this.OrderForm.controls.country.valueChanges.subscribe( newCountry => {
			if ( newCountry == "US" ) {
				console.log("GO USA");
                // this.OrderForm.get('state').setValue("NA");
                // this.OrderForm.get('statepicker').setValue("");
				this.OrderForm.controls.zipCode.setValidators(usZipValidators);
			} else {
				console.log("GO " + newCountry +"?");
                // this.OrderForm.get('state').setValue("");
                // this.OrderForm.get('statepicker').setValue("NV");   
				this.OrderForm.controls.zipCode.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(10)]);
			}
			this.OrderForm.updateValueAndValidity();
		});

        this.OrderForm.controls.zipCode.valueChanges.subscribe((value) => {
            if (!this.IsUS()) {
                return;
            }
            // remove spaces
            let trimmed = value.replace(/\s+/g, '');

            trimmed = trimmed.replace(/[^\d]/g, "");

            if (trimmed.length > 5) {
                trimmed = trimmed.substr(0, 5);
            }

            if (value !== trimmed) {
                this.OrderForm.controls.zipCode.setValue(trimmed);
            }
        });

        this.OrderForm.controls.phone.valueChanges.subscribe((value) => {
            if (value !== this.getPhoneInputValue(value)) {
                this.OrderForm.controls.phone.setValue(
                    this.getPhoneInputValue(value)
                );
            }
        });

        // SET UP YEAR RANGE FOR CREDIT CARD EXPIRATION DATE FIELD
        for (let i: number = 0; i < 15; i++) {
            this.YearRange.push(this.Year + i);
        }

        // assign product from routed parameters and refresh the public product list
        this.refreshProducts();

        // create CardID if not exist
        this.GetCartID();

        // SHOW COMPLETE ORDER DIALOG TEST -- mike
        // this.showCompleteOrderDialog("UFOID");
        this.thisIsDev = this.api.isDev;

        let disposable = this.OrderForm.controls.ccNr.valueChanges.subscribe( val => {
            
            console.log(val);
            //this.CheckCredtiCardType(val);            

        });


    }

    

    CheckCredtiCardType( value : string ) {
        
        console.log("Credit Card Value : " + value);
        let cardType : CreditCardTypes = CreditCardHelper.GetCardTypes( value );
        this.cardType = cardType;
        console.log(this.cardType);
        let newCardType : string = cardType.toString().toLowerCase();

        this.ccardTypeClass = newCardType;

    }


    ThisMonth() {
        const month = new Date().getMonth() + 1;

        if (month < 10) {
            return '0' + month;
        } else {
            return month;
        }
    }

    matchedFieldChanged() {
        this.OrderForm.controls['password'].updateValueAndValidity();
        this.OrderForm.controls['password1'].updateValueAndValidity();

        // this.OrderForm.controls["email"].updateValueAndValidity();
        // this.OrderForm.controls["email1"].updateValueAndValidity();
    }

    GetCartID() {

        this.CartID = localStorage.getItem('cartID');

        if (this.CartID != undefined) {
            // console.log("CartID exist:", this.CartID);
            return;
        }

        // console.log("New CartID:", this.CartID);
        this.CartID = this.generateUUID();
        localStorage.setItem('cartID', this.CartID);
    }

    generateUUID() {
        let d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            d += performance.now();
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    assignRouteParams(newParams: object) {
        // MAKE SURE NEWPARAMS IS DEFINED, IF NOT ASSIGN DEFAULT PRODUCT ID
        // console.log(newParams);
        if (this.isEmpty(newParams)) {
            this.SelectedProduct.ProductID = 0;
            // this.SelectedBillingCycle = 1;
            // console.log("newParams object was empty");
            return;
        }

        // ASSIGN ACTIVATED ROUTE PARAMETERS
        let newProductID = Number(newParams['productID']);
        let newCycleID = Number(newParams['cycleID']);
        let newYardAddOn = Number(newParams['yardAddOn']);
        this.marketTag = String(newParams['marketTag']);
        // console.log("marketTag = " + this.marketTag);
        // MAKE SURE NEW ID's FALLS INTO ACCEPTABLE RANGE
        if (newCycleID < 1)
            newCycleID = 1;



        // ASSIGN PRODUCT ID AND BILLING CYCLE ID
        this.SelectedProduct.ProductID = newProductID;
        this.SelectedBillingCycle = newCycleID;

        // console.log("newYardAddOn = " + newYardAddOn + " ProductID = " + this.SelectedProduct.ProductID);

        if (newYardAddOn == 0 || this.SelectedProduct.ProductID != 0)
            this.yardAddOn = false;
        else
            this.yardAddOn = true;

        if (this.SelectedProduct.ProductID == 0)
            this.yardAddOnOption = true;

        // console.log("newCycleID", newCycleID, "  Selected Billing Cycle = ", this.SelectedBillingCycle);

        // ASSIGN MONTHYL/YEARLY SELECTION
        if (this.SelectedBillingCycle == 2) {
            // this.billingCycleSelect.value = '2';
            let mySelect: any = document.getElementById('billingCycleSelect');
            mySelect.value = 2;
        }


    }

    refreshProducts() {

        this.IsBusy = true;
        let subScription = this.api.ProductsPublicAndSpecialOrderProducts()
            .subscribe((response) => {
                console.log("prodresponse", response);
                subScription.unsubscribe();

                if (response.Result)
                    this.Products = response.Data;
                else
                    this.Products = new PublicOrderProductsResponseArray();

                let newProductName = 'VIP3D';

                if (this.routeParams['productID'] != undefined) {
                    if (this.routeParams['productID'] == '0') {
                        newProductName = 'VIP3D';
                    } else if (this.routeParams['productID'] == '1') {
                        newProductName = 'Pool Studio';
                    } else if (this.routeParams['productID'] == '2') {
                        newProductName = 'VizTerra';
                    } else {
                        newProductName = this.routeParams['productID'].replace(/_/g, ' ');
                        if (newProductName.toLowerCase().includes('special'))
                            this.isSpecial = true;
                        else if (newProductName.toLowerCase().includes("promo"))
                            this.isPromo = true;                            
                    }
                }

                this.assignRouteParams(this.routeParams);
				// this.personService.getPersons().find(x => x.id == this.personId);
				
				let newProductID : number = -1;

				for( var i = 0; i < response.Data.length; i++ ) {
					if( response.Data[i].Name == newProductName ) {
						newProductID = response.Data[i].ProductID;
                        this.TaxEnabled = response.Data[i].TaxEnabled;
						break;
					}
				}


				//let newProductID : number = response.Data.find(x => x.Name == newProductName).ProductID;

				if( newProductID == -1 ) {
					// No product Found
                    console.log("NO PRODUCT!!!!");
                    console.log("t1", newProductName);
                    console.log("t2", response.Data);

					this.ShowProductNotFoundDialog();
				} else {
					// Found a valid Product
					this.ProductChanged( newProductID );
				}

				
				if( newProductName == 'VIP3D' ) {
					this.trainingValue = '2,425';
				} else if ( newProductName == "VizTerra" ) {
					this.trainingValue = '2,090';
				}


			// this.IsBusy = false;
			},
			(error: any) => {
				this.IsBusy = false;
		});

    }

    makePriceLookNice(thePrice: any): string {
        return thePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    totalPrice(): number {
        let newTotal = this.SelectedPrice + this.SelectedSetupFee;
        if (this.yardAddOn)
            newTotal += this.yardPrice;
        return newTotal;
    }

    totalTaxDisplay(): string {
        let newTax = this.TaxAmount;
        if (this.yardAddOn)
            newTax += this.YardTax;

        if (newTax == 0 || (newTax * 100).toString().endsWith("00")){
            return newTax.toString();
        }
        else{
            return(Math.round( newTax * 100) / 100).toFixed(2);
        }        
    }

    totalTax(): number {
        let newTax = this.TaxAmount;
        if (this.yardAddOn)
            newTax += this.YardTax;
        return newTax;        
    }    

    totalPriceWithTax(): string {
        let newTotalWithTax = this.SelectedPrice + this.SelectedSetupFee + this.totalTax();
        if (this.yardAddOn)
            newTotalWithTax += this.yardPrice;

        if ((newTotalWithTax * 100).toString().endsWith("00")){
            return newTotalWithTax.toString();
        }
        else{
            return(Math.round( newTotalWithTax * 100) / 100).toFixed(2);
        }
    }


    isEmpty(obj): boolean {
        for (let key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    isValidExpiration() {
        let ccExpMonth = this.OrderForm.get('ccExpMonth').value;
        let ccExpYear = this.OrderForm.get('ccExpYear').value;

        if (moment(ccExpMonth + '/' + ccExpYear, 'MM/YYYY').isSameOrAfter(moment(moment().format('MM/YYYY'), 'MM/YYYY'))) {
            return true;
        } else {
            return false;
        }
    }

    onExpirationChange() {
        this.ExpirationChanged = true;
        this.UpdateCart();
    }

    isFormValid(): boolean {
        // isCompareValid( passwordRepeat.value, password.value ) == true && isCompareValid( email.value, email1.value ) == true && email.value != '' && password.value != ''
        let ccNameOnCard = this.OrderForm.get('ccNameOnCard').value;
        this.getNameOnCard(ccNameOnCard);
        let ccExpMonth = this.OrderForm.get('ccExpMonth').value;
        let ccExpYear = this.OrderForm.get('ccExpYear').value;

        if (this.ccLastName == '')
            return false;

        if (!this.OrderForm.valid)
            return false;

        if (!this.isValidExpiration())
            return false;

        if (this.orderFormSubmited)
            return false;

        return true;
    }

    hasLastName(): boolean {

        let ccNameOnCard = this.OrderForm.get('ccNameOnCard').value;
        this.getNameOnCard(ccNameOnCard);
        if (this.ccLastName == '')
            return false;

        return true;

    }

    

    CheckMember() {

        if( this.isCheckingMember ) return;

        if ( !this.OrderForm.controls['email'].valid ) return;
        
        this.isCheckingMember = true;
        
        let email = this.OrderForm.controls['email'].value;
        
        let request: CheckForExistingMemberRequest = {
            Checksum: 'ADSFEWFF~!OMG1ITS5SNOWING3INVEGAS42!!!AND6ALL4FROZEN7DRINKS3ARE22HALF00OFF43IN65THE998CASINO',
            Email: email
        };


        let disposable = this.api.CheckForExistingMember(request).subscribe(response => {
            
            disposable.unsubscribe();

            this.isCheckingMember = false;

            let existingMemberResponse : CheckForExistingMemberResponse = response.Data;

            console.log('existingmemberresponse = ', existingMemberResponse );

            if (existingMemberResponse.PromptToLoginOnOrderForm) {
                
                localStorage.setItem('email', email);

                
                switch (existingMemberResponse.MemberType) {
                    case 100:
                    case 110: {
                        // Active Member && Cancelled Member
                        this.ShowLoginDialog();
                        break;
                    }
                    case 200:
                    case 210: {
                        // Cancelled Designer && Active Designer
                        Swal.fire({
                            icon: 'warning',
                            title: 'Warning',
                            text: 'It looks like you already have a designer profile registered to this email address. Please use a different email address.'
                        }).then(() => {
                            // this.router.navigate(['/'])
                            this.OrderForm.controls['email'].setValue('');
                            this.EmailField.nativeElement.focus();
                        }, () => {
                            // this.router.navigate(['/'])
                            this.OrderForm.controls['email'].setValue('');
                            this.EmailField.nativeElement.focus();
                        });
                        break;
                    }
                }
            } else if ( existingMemberResponse.PromptToFinishOrder && existingMemberResponse.UFOID) {
                this.dialogService.open(CompleteOrderDialogComponent, {data: {
                    UFOID: existingMemberResponse.UFOID,
                    fromLogin : false,
                }});
                this.OrderForm.controls['email'].setValue('');
                this.EmailField.nativeElement.focus();
            }
            
        });
    }

    ShowLoginDialog() {
        this.dialogService.open(LoginDialogComponent, {data: {
            IsWelcomeBack: true,
            ProductID: this.SelectedProduct.ProductID,
            BillingCycle: this.SelectedBillingCycle,
            HasYard: this.yardAddOn
        }});
        this.OrderForm.controls['email'].setValue('');
        this.EmailField.nativeElement.focus();
    }

    BillingCycleChanged(billingCycleType: BillingRecurringTypes) {

        // set billing
        this.SelectedBillingCycle = billingCycleType;

        // set type  based on new billing
        this.SelectedPrice = this.SelectedProduct
            .Prices
            .find(x => x.BillingCycle == billingCycleType)
            .Price;

        this.SelectedSetupFee = this.SelectedProduct
            .Prices
            .find(x => x.BillingCycle == billingCycleType)
            .Setup;

        if (this.yardAddOn && this.SelectedProduct.YardAddon != null) {
            this.yardPrice = this.SelectedProduct.YardAddon.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Price;
            this.yardSetup = this.SelectedProduct.YardAddon.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Setup;
            this.YardTax = this.yardPrice * (this.TaxRate / 100);
            this.YardTax = this.YardTax * 100;
            this.YardTax = Math.round(this.YardTax);
            this.YardTax = this.YardTax / 100;
        } else {
            this.yardPrice = 0;
            this.yardSetup = 0;
            this.YardTax = 0;
        }
        this.UpdatePageTitle();
        if (!this.SkipUpdteCart)
            this.UpdateCart();
    }

    ProductChanged(productID: number) {

        // set product
        this.SelectedProduct = this.Products.find(x => x.ProductID == productID);
        this.SelectedSetupFee = this.SelectedProduct.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Setup;

        if (this.yardAddOn && this.SelectedProduct.YardAddon != null) {
            this.yardPrice = this.SelectedProduct.YardAddon.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Price;
            this.yardSetup = this.SelectedProduct.YardAddon.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Setup;
        } else {
            this.yardPrice = 0;
            this.yardSetup = 0;
        }


        // set price based on new product
        this.BillingCycleChanged(this.SelectedBillingCycle);

        // console.log("Prodcut Name:", this.SelectedProduct.Name);
        // console.log("Setup Fee:", this.SelectedSetupFee);

        this.formProductClass = this.SelectedProduct.Name.replace(/\s+/g, '');

        this.titleService.setTitle('Order Form | ' + this.SelectedProduct.Name);
        this.UpdatePageTitle();

        if (!this.SkipUpdteCart)
            this.UpdateCart();

    }

    UpdatePageTitle() {
        let cycleName = 'Monthly';
        if (this.SelectedBillingCycle == 2) {
            cycleName = 'Yearly';
        }
        //console.log(this.SelectedBillingCycle);
        this.titleService.setTitle(this.SelectedProduct.Name + ' Order Form - Review Your ' + cycleName + ' Membership Plan');
    }

    checkEmailValid(): boolean {

        let Email = this.OrderForm.get('email');
        // let Email1 = this.OrderForm.get('email1');

        // if (!Email.touched || !Email.touched)
        //     return false;

        // if (!Email.valid || !Email1.valid)
        //     return false;

        // if (Email.value != Email1.value)
        //     return false;

        return true;
    }

    isCompareValid(myField: string, compareField: string): boolean {
        return myField == compareField;
    }

    checkPasswordValid(): boolean {

        let Email = this.OrderForm.get('password');
        let Email1 = this.OrderForm.get('password1');

        if (!Email.touched || !Email.touched)
            return false;

        if (!Email.valid || !Email1.valid)
            return false;

        if (Email.value != Email1.value)
            return false;

        return true;
    }

    isFieldValid(fieldName: string): boolean {

        if (this.OrderForm.get(fieldName).value != '')
            return true;
        else
            return false;

    }

    StripNonNumeric(strValue: string): number {

        let value = strValue.replace(/[^\d]/g, ''); // 1238

        if (value == '')
            return 0;
        else
            return <any>value;

    }


    GetNewMemberRequest(): NewMemberRequest {



        // credit card names
        let ccNameOnCard = this.OrderForm.get('ccNameOnCard').value;
        this.getNameOnCard(ccNameOnCard);

        // credit card expiration month
        let ccExpMonth = this.OrderForm.get('ccExpMonth');
        if (ccExpMonth == undefined)
            throw RangeError('Credit Card Expiration Month Value Error');

        // credit card expiration year
        let ccExpYear = this.OrderForm.get('ccExpYear');
        if (ccExpYear == undefined)
            throw RangeError('Credit Card Expiration Year Value Error');

        // check email
        if (!this.checkEmailValid())
            throw Error('Invalid Email.');

        // check password
        if (!this.checkPasswordValid())
            throw Error('Invalid Password.');


        // prepare object to return
        let data = new NewMemberRequest();
        data.Checksum = "33022hTllpOOO99#$%^ABlpse634!!dss66kfpEFes46^^sdd2";
        data.OrderFormVersion = this.gb.OrderFormVersion;

        // - personal
        data.FirstName = this.OrderForm.get('firstName').value;
        data.LastName = this.OrderForm.get('lastName').value;
        data.Email = this.OrderForm.get('email').value;
        data.Company = this.OrderForm.get('company').value;
        data.Phone = this.OrderForm.get('phone').value.replace(/[^\d]/g, "");
        data.Password = this.OrderForm.get('password').value;

        // - address
        data.Address1 = this.OrderForm.get('address1').value;
        data.City = this.OrderForm.get('city').value;
        data.Country = this.OrderForm.get('country').value;

        if (data.Country == "US"){
            data.State = this.OrderForm.get('statepicker').value;
        }
        else{
            data.State = this.OrderForm.get('state').value;
        }

        data.ZipCode = this.OrderForm.get('zipCode').value;

        // - credit card
        data.CC_FirstName = this.ccFirstName;
        data.CC_LastName = this.ccLastName;


        data.CC_Number = this.OrderForm.get('ccNr').value;

        this.CheckCredtiCardType(data.CC_Number);

        if(this.cardType == CreditCardTypes.Unknown) {
            throw Error('Unknown Credit Card Type');
        }
        
        data.CC_Number = this.StripNonNumeric(data.CC_Number).toString();

        if (data.CC_Number == '' ||
            data.CC_Number.length < 13)
            throw Error('Invalid Credit Card Number.');



        data.CC_ExpMonth = ccExpMonth.value;
        data.CC_ExpYear = ccExpYear.value - 2000;
        data.CC_CVC = this.OrderForm.get('ccCVC').value;
        data.CC_Address1 = data.Address1;
        data.CC_City = data.City;
        data.CC_Country = data.Country;
        data.CC_State = data.State;
        data.CC_ZipCode = data.ZipCode;

        // - product
        data.ProductID = this.SelectedProduct.ProductID;
        data.BillingCycle = this.SelectedBillingCycle;
        data.AddYard = this.yardAddOn;



        // - initals
        data.Initials = this.OrderForm.get('confirmInitials').value;

        // - redirect/referral
        let strRedirectID = localStorage.getItem('s_redirect_id');
        let RedirectCreated = localStorage.getItem('s_redirect_created');
        let RedirectID = 0;

        if (strRedirectID != undefined)
            RedirectID = parseInt(strRedirectID);

        if (RedirectID > 0) {
            data.RedirectID = RedirectID;
            data.DateTimeRedirectClick = new Date(RedirectCreated);
        }

        data.AssignToOwner = false;

        // console.log("Request Data: ", data);
        return data;
    }

    GetUpdateCartRequest(): UpdateCartRequest {

        // prepare object to return
        let data = new UpdateCartRequest();

        // cart
        data.CartID = this.CartID;

        // - personal
        data.FirstName = this.OrderForm.get('firstName').value;
        data.LastName = this.OrderForm.get('lastName').value;
        data.Email1 = this.OrderForm.get('email').value;
        // data.Email2 = this.OrderForm.get('email1').value;
        data.Company = this.OrderForm.get('company').value;
        data.Phone = this.gb.FormattedPhone(this.OrderForm.get('phone').value);

        // - address
        data.Address = this.OrderForm.get('address1').value;
        data.City = this.OrderForm.get('city').value;
		data.Country = this.OrderForm.get('country').value;

        if (data.Country == "US"){
            data.State = this.OrderForm.get('statepicker').value;
        }
        else{
            data.State = this.OrderForm.get('state').value;
        }
		
		data.ZipCode = this.OrderForm.get('zipCode').value;
		

        // - credit card
        data.CCName = this.OrderForm.get('ccNameOnCard').value;
        data.CCNumber = this.OrderForm.get('ccNr').value;
        data.CCLastFour = data.CCNumber.slice(data.CCNumber.length - 4);
        data.CCExpMonth = Number(this.OrderForm.get('ccExpMonth').value);
        data.CCExpYear =  Number(this.OrderForm.get('ccExpYear').value) - 2000;

        // - product
        data.ProductID = this.SelectedProduct.ProductID;
        data.BillingCycle = this.SelectedBillingCycle;

        // - Initals
        data.Initials = this.OrderForm.get('confirmInitials').value;

        //taxes
        data.TaxChecksum = "s53f4s56dfa4fs6ljsdhfasdlfAFDASKHflash5646asdf";
        data.SubTotal = this.totalPrice();        

        // - redirect/referral
        let strRedirectID = localStorage.getItem('s_redirect_id');
        let RedirectCreated = localStorage.getItem('s_redirect_created');
        let RedirectID = 0;

        if (strRedirectID != undefined)
            RedirectID = parseInt(strRedirectID);

        if (RedirectID > 0) {
            data.RedirectID = RedirectID;
            data.DateTimeRedirectClicked = new Date(RedirectCreated);
        }

        console.log("Request Cart Update Data: ", data);
        return data;
    }

    getNameOnCard(nameString: string) {

        this.ccFirstName = '';
        this.ccLastName = '';

        let namesSplit = nameString.split(' ');

        if (namesSplit.length == 0)
            return;

        let firstName = namesSplit[0];

        let lastName = '';

        if (namesSplit.length > 1) {
            for (let i = 1; i < namesSplit.length; i++) {
                if (i != 1)
                    lastName += ' ';

                lastName += namesSplit[i];
            }
        }

        this.ccFirstName = firstName;
        this.ccLastName = lastName;

    }



    async onOrderFormSubmit() {

        // Check to see if our order form has been submitted and cancel the submit action
        if (this.orderFormSubmited) return;

        this.orderFormSubmited = true;

        this.IsBusy = true;
        // get data
        let data: NewMemberRequest;

        try {
            data = this.GetNewMemberRequest();
        } catch (e) {
            // console.log("error:", e);
            xToastr.ShowToast(ToastrTypes.Error, 'Validation Errors', e);
            this.IsBusy = false;
            return;
        }

        console.log("request data", data);
        
        //if( 0 == 0 ) return;
        
        let request = this.api.MemberNew(data)
            .subscribe(response => {
                // console.log("response received");
                // console.log(response)


                if (!response.Result)
                    switch (response.ErrCode) {
                        case '0':
                            // user exists
                            // console.log("Error response");
                            xToastr.ShowToast(ToastrTypes.Error, 'Error', 'This user already exists.');
                            this.IsBusy = false;
                            this.orderFormSubmited = false;
                            return;

                        case '1':
                            // Error Creating Member
                            // console.log("Error response");
                            xToastr.ShowToast(ToastrTypes.Error, 'Unkown Error', 'New user could not be created.');
                            this.IsBusy = false;
                            this.orderFormSubmited = false;
                            return;

                        case '2':
                            // payment
                            // unfinished order
                            this.showCompleteOrderDialog(response.Message);
                            this.IsBusy = false;
                            this.orderFormSubmited = false;
                            return;

                        case '3':
                            // member exists but we couldn't authenticate or something else went wrong
                            localStorage.setItem('WelcomeBack', '1');
                            this.router.navigate(['/authentication/signin/welcome-back']);
                            return;

                        case '17':
                            let options = {
                                closeButton: true,
                                progressBar: true,
                                debug: true,
                                preventDuplicates: true,
                                positionClass: 'toast-top-center',
                                onclick: null,
                                showDuration: 400,
                                hideDuration: 1000,
                                timeOut: 30000,
                                extendedTimeOut: 1000,
                                showEasing: 'swing',
                                hideEasing: 'linear',
                                showMethod: 'fadeIn',
                                hideMethod: 'fadeOut'
                            };
                            xToastr.ShowToast(ToastrTypes.Error, 'Error', 'This email is linked to a cancelled membership. Please provide a new email address to create a new membership. If you would like to reactivate, contact your account owner or call us at 702-433-0274.', options);
                            this.IsBusy = false;
                            this.orderFormSubmited = false;
                            return;

                        case '19':
                        case '20':
                            // user exists
                            // console.log("Error response");
                            xToastr.ShowToast(ToastrTypes.Error, 'Error', 'A member already exists with this email. Please log in or use a different email address.');
                            this.IsBusy = false;
                            this.orderFormSubmited = false;
                            return;

                        default:
                            // user exists
                            // console.log("Error response");
                            xToastr.ShowToast(ToastrTypes.Error, 'Error', 'Error processing request. Your Card has been declined.');
                            this.IsBusy = false;
                            this.orderFormSubmited = false;
                            return;
                    }



                // ok

                //  window.location.href = "https://www.structurestudios.com/thank-you";
                // console.log(response);
                // console.log(response.Data);

                // we are authenticated
                let Response: NewMemberResponse = <any>response.Data;

                if (Response.Reactivated && Response.ReturningMember) {
                    // we were able to reactivate this member
                    // redirect to welcome back page or dashboard
                    // we are authenticated
                    this.gb.SetGlobalsFromLoginResponse(Response.LoginResponse);
                    // HERE MIKE
                    localStorage.setItem('WelcomeBack', '1');
                    this.router.navigate(['account/product-memberships']);
                    return;
                } else if (!Response.Reactivated && Response.ReturningMember) {
                    // we are a returning member and we couldn't reactivate.
                    // redirect to welcome back or tell the member that the email already exists
                    // HERE MIKE
                    localStorage.setItem('WelcomeBack', '1');
                    this.router.navigate(['/authentication/signin/welcome-back']);
                    return;
                } else {
                    // we are a new member
                    this.gb.SetGlobalsFromLoginResponse(Response.LoginResponse);
                    window.location.href = this.getRedirectURL();

                }




            },

                (error: HttpError) => {

                    // this.ResetSigninFormSubmitRequest(request);
                    this.orderFormSubmited = false;
                    this.IsBusy = false;
                    xToastr.ShowToast(ToastrTypes.Error, error.FriendlyTitle, error.FriendlyMessage);

                }
            );

    }

    logoLoaded() {
        // console.log("IsBusy on the logoLoaded method = " + this.IsBusy);
        this.IsBusy = false;
    }

    UpdateCart() {
        if( this.isCheckingMember ) return;

        this.SkipUpdteCart = false;

        let data = this.GetUpdateCartRequest();

        if (!this.CheckUpdateCart(data))
            return;

        this.LastUpdateCartRequest = data;

        let subscription = this.api.SalesUpdateCart(data)
            .subscribe(          
                (result) => { 
                    console.log("datarec");
                    console.log(result.Data);
                    console.log("dataend");
                    this.TaxAmount = result.Data.TaxAmount;
                    this.TaxEnabled = result.Data.TaxEnabled;
                    this.TaxRateDisplay = result.Data.TaxRateDisplay;
                    this.TaxAmount = result.Data.TaxAmount;
                    this.TaxCalculated = result.Data.TaxCalculated;
                    if (this.IsUS()) {
                        if (this.TaxCalculated) {
                            this.OrderForm.controls.zipCode.setErrors(null);
                        } else {
                            this.OrderForm.controls.zipCode.setErrors({
                                invalid: true
                            });
                        }    
                    }
                    this.OrderForm.updateValueAndValidity();
                    this.TaxRate = result.Data.TaxRate;
                    subscription.unsubscribe();
                    this.updateState(result.Data.State);
                },
                (error) => { 
                    subscription.unsubscribe();
                }
            );

    }

    updateState(state) {
        const curState = this.orderFormControls.statepicker.value || this.orderFormControls.state.value;
        const curZipCode = this.orderFormControls.zipCode.value;
        const dualStates = DualStateZipcodeList[curZipCode] || [];
        if (!dualStates.includes(curState)) {
            this.State = state;
            this.OrderForm.get('statepicker').setValue(this.State);
            this.OrderForm.get('state').setValue(this.State);
            this.OrderForm.updateValueAndValidity();
        }
    }

    CheckUpdateCart(newCartData: UpdateCartRequest): boolean {

        if (this.LastUpdateCartRequest == undefined)
            return true;

        if (newCartData.ProductID != this.LastUpdateCartRequest.ProductID)
            return true;

        if (newCartData.BillingCycle != this.LastUpdateCartRequest.BillingCycle)
            return true;

        if (newCartData.FirstName != this.LastUpdateCartRequest.FirstName)
            return true;

        if (newCartData.LastName != this.LastUpdateCartRequest.LastName)
            return true;

        if (newCartData.Initials != this.LastUpdateCartRequest.Initials)
            return true;

        if (newCartData.Address != this.LastUpdateCartRequest.Address)
            return true;

        if (newCartData.City != this.LastUpdateCartRequest.City)
            return true;

        if (newCartData.ZipCode != this.LastUpdateCartRequest.ZipCode)
            return true;

        if (newCartData.State != this.LastUpdateCartRequest.State)
            return true;

        if (newCartData.Country != this.LastUpdateCartRequest.Country)
            return true;

        if (newCartData.CCName != this.LastUpdateCartRequest.CCName)
            return true;

        if (newCartData.Company != this.LastUpdateCartRequest.Company)
            return true;

        // if (newCartData.Email1 != this.LastUpdateCartRequest.Email1)
        //     return true;

        if (newCartData.Email2 != this.LastUpdateCartRequest.Email2)
            return true;

        if (newCartData.Phone != this.LastUpdateCartRequest.Phone)
            return true;

        if (newCartData.CCExpMonth != this.LastUpdateCartRequest.CCExpMonth)
            return true;

        if (newCartData.CCExpYear != this.LastUpdateCartRequest.CCExpYear)
            return true;

        if (newCartData.CCNumber != this.LastUpdateCartRequest.CCNumber)
            return true;

        if (newCartData.CCLastFour != this.LastUpdateCartRequest.CCLastFour)
            return true;

    }

    // ///////////////////////////////////////
    // SHOW COMPLETE ORDER FORM DIALOG
    // ///////////////////////////////////////
    showCompleteOrderDialog(ufoid: string) {

        // this.IsBusy = true;

        this.dialogService.open(CompleteOrderDialogComponent, {data: {
            UFOID : ufoid,
            fromLogin : false,
        }});


    }


    getRedirectURL(): string {
        let membershipName = this.SelectedProduct.Name.toString().toLowerCase();
        membershipName = membershipName.replace(/\s+/g, '');
        let billingCycle = 'monthly';

        // console.log("this.selectedCycle: " + this.SelectedBillingCycle)

        if (this.SelectedBillingCycle == 2)
            billingCycle = 'yearly';

        return 'order-form/thank-you/' + membershipName + '-' + billingCycle;
    }

    GotoThankYouPage() {
        window.location.href = this.getRedirectURL();
        // console.log("Thank You URL: ", this.getRedirectURL() );
    }

    yardAddOnCheckChanged(e: any) {
        // console.log("yardAddOn now = " + this.yardAddOn);
        // console.log(e.target.checked);

        this.yardAddOn = e.target.checked;
        this.BillingCycleChanged(this.SelectedBillingCycle);

    }

    isVipName(Name: string): boolean {
        if (Name != undefined)
            return Name.toLowerCase().includes('vip3d');
        else
            return false;
    }

    isVizterraName(Name: string): boolean {
        if (Name != undefined)
            return Name.toLowerCase().includes('vizterra');
        else
            return false;
    }

    isPoolStudioName(Name: string): boolean {
        if (Name != undefined)
            return Name.toLowerCase().includes('pool studio');
        else
            return false;
	} 
	


	ShowProductNotFoundDialog() {

		var pricingURL : string = "https://www.structurestudios.com/landscape-design-software-and-pool-design-software-pricing";

		Swal.fire({
			icon: 'error',
			title: 'We\'re Sorry',
			text: 'The promotion is no longer available',
			showCloseButton: true,
            confirmButtonText: 'View our products',
            allowOutsideClick: false,
		}).then(() => {
			// this.router.navigate(['/'])
			window.open( pricingURL, '_self');
		}, () => {
			// this.router.navigate(['/'])
			window.open( pricingURL, '_self');
		});

	}

    IsUS() : boolean {
		return this.OrderForm.controls.country.value == 'US' ? true : false;
	}

    public getPhoneInputValue( v : string ) : string {
		

		// trim '-' dashes
		v = v.replace(/-/g,'');

		v = v.replace(/[^\d]/g, "");
		
		// trim string to 15 characters
		if( v.length > 10) {
			if (v.length > 15) {
				v = v.substr(0, 15);
			}
			return '   +' + v;
		}
		

      // new array to hold sections of the License Key
		let numbers = [];

		// create set of characters from first 5 characters
		numbers.push(v.substr(0,3));
		
		// try for next 5
		if(v.substr(3,3)!=="")
			numbers.push(v.substr(3,3));
		
		// and last set of 5
		if(v.substr(6,10)!="")
			numbers.push(v.substr(6,4));
		
		if(v.substr(10,15)!="")
			numbers.push(v.substr(10,5));

		// add '-' dashes back to formated string
		let newValue = numbers[0];
		
		//if( newValue.length == 3 ) {
			
		//}

		if( numbers.length > 1 ) {
			newValue = '(' + newValue + ') ';
			newValue += numbers[1];
		}
			

		if (numbers.length > 2 )
			newValue += '-' + numbers[2];

		// if (numbers.length > 3 )
		// 	newValue += '-' + numbers[3];

		return newValue;
	}

    get orderFormControls() { return this.OrderForm.controls; }

    // Start Google Place API
    getAddress(place: object) {
        // this.address = place['formatted_address'];
        // this.phone = this.getPhone(place);
        // this.formattedAddress = place['formatted_address'];
        // this.zone.run(() => this.formattedAddress = place['formatted_address']);
        const street = this.getStreet(place);
        const district = this.getDistrict(place);
        const city = this.getCity(place);
        const state = this.getStateShort(place);
        const postCode = this.getPostCode(place);
        const country = this.getCountryShort(place);
        // this.orderFormControls.street.patchValue(street);
        this.orderFormControls.address1.patchValue(street);
        this.orderFormControls.city.patchValue(city);
        this.orderFormControls.state.patchValue(state);
        this.orderFormControls.statepicker.patchValue(state);
        this.orderFormControls.zipCode.patchValue(postCode);
        this.orderFormControls.country.patchValue(country);
        setTimeout(() => {
            this.UpdateCart();            
        });
    }

    getAddrComponent(place, componentTemplate) {
        let result;

        for (let i = 0; i < place.address_components.length; i++) {
        const addressType = place.address_components[i].types[0];
        if (componentTemplate[addressType]) {
            result = place.address_components[i][componentTemplate[addressType]];
            return result;
        }
        }
        return;
    }

    getStreetNumber(place) {
        const COMPONENT_TEMPLATE = { street_number: 'short_name' },
        streetNumber = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return streetNumber;
    }

    getStreet(place) {
        const COMPONENT_TEMPLATE = { street_number: 'long_name' },
        streetNumber = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        const COMPONENT_TEMPLATE1 = { route: 'long_name' },
        route = this.getAddrComponent(place, COMPONENT_TEMPLATE1);
        const street = streetNumber ? (streetNumber + ' ' + route) : route;
        return street || place['formatted_address'];
    }

    getCity(place) {
        const COMPONENT_TEMPLATE = { locality: 'long_name' },
        city = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return city || '';
    }

    getState(place) {
        const COMPONENT_TEMPLATE = { administrative_area_level_1: 'long_name' },
        state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return state || '';
    }

    getStateShort(place) {
        const COMPONENT_TEMPLATE = { administrative_area_level_1: 'short_name' },
        stateShort = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return stateShort || '';
    }

    getDistrict(place) {
        const COMPONENT_TEMPLATE = { administrative_area_level_2: 'short_name' },
        state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return state || '';
    }

    getCountryShort(place) {
        const COMPONENT_TEMPLATE = { country: 'short_name' },
        countryShort = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return countryShort || '';
    }

    getCountry(place) {
        const COMPONENT_TEMPLATE = { country: 'long_name' },
        country = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return country || '';
    }

    getPostCode(place) {
        const COMPONENT_TEMPLATE = { postal_code: 'long_name' },
        postCode = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return postCode || '';
    }

    getPhone(place) {
        const COMPONENT_TEMPLATE = { formatted_phone_number: 'formatted_phone_number' },
        phone = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return phone || '';
    }
    // End Google Place API
}
